export * as DropdownMenuComp from "./dropdown-menu";
